/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * Status of the user deactivation.
 **/
export var UserDeactivationStatus;
(function (UserDeactivationStatus) {
    UserDeactivationStatus["COMPLETED"] = "COMPLETED";
    UserDeactivationStatus["NO_DATA"] = "NO_DATA";
})(UserDeactivationStatus || (UserDeactivationStatus = {}));
